import { Component, OnInit, Input } from '@angular/core';
import { ZipCountyStateStructure } from 'src/app/angular-elements/shared/interfaces/zipCountyStateStructure.interface';
import { ReducerUtilityService } from 'src/app/shared/utility-services/reducer-utility.service';
import { ZipCountyModalComponent } from 'src/app/angular-elements/demographics/zip-county-modal/zip-county-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { select } from '@ptl/angular-redux-store';
import { Observable } from 'rxjs';
import { EffectiveDateStateStructure } from '../configs/interfaces/effective-date.state-structure.interface';
import { DateService } from 'src/app/shared/services/date.service';

@Component({
    selector: 'app-current-county-and-zip-change',
    templateUrl: './current-county-and-zip-change.component.html',
    styleUrls: ['./current-county-and-zip-change.component.scss'],
    standalone: false
})
export class CurrentCountyAndZipChangeComponent implements OnInit {


  @Input() viewPlansUrl: string;
  @Input() recommendedPlansUrl: string;
  @Input() buttonStyle: string;
  @Input() tabPreselect: string;

  @Input() modalHeading: string;
  @Input() modalContentMain: string;
  @Input() modalButtonLabel: string;

  @Input() hideYearSelection: string;

  @Input() currentYearOverride: string;
  @Input() selectYearHeading: string;
  @Input() selectYearPrompt: string;
  @Input() initialYearSelection: string = 'nextYear';
  @Input() tooltipText: string;

  @Input() isIndividual = false;
  @Input() marketingSubHeader: string;
  @Input() availablePlans: string;
  displayEffectiveDate = '';

  @select(['appStates', 'EffectiveDate']) effectiveDate$: Observable<any>;
  countyInfo: ZipCountyStateStructure;
  effectiveDate: EffectiveDateStateStructure;
  yearSelected: string;

  constructor(
    private date: DateService,
    private matDialog: MatDialog,
    private reducerUtilityService: ReducerUtilityService
  ) { }

  ngOnInit() {

    this.countyInfo = this.reducerUtilityService.getState('ZipCounty');

    this.effectiveDate$.subscribe((value) => {
      this.effectiveDate = value || {};
      this.yearSelected = this.effectiveDate.effectiveDateYear || 'Year Not Chosen';
      this.displayEffectiveDate = this.date.getDateAsFormattedString(this.effectiveDate.effectiveDate, 'MM/DD/YYYY');
    });

  }

  changeZip() {
    this.matDialog.open(ZipCountyModalComponent, {
      maxHeight: '100vh',
      maxWidth: '650px',
      data: {
        viewPlansUrl: this.viewPlansUrl,
        recommendedPlansUrl: this.recommendedPlansUrl
      }
    });
  }

  isMultiBrandASP() {
    return !environment.initData.brand.singleBrandASP;
  }
}
